import { render, staticRenderFns } from "./leaderboard.vue?vue&type=template&id=3dedd6fa&scoped=true"
import script from "./leaderboard.vue?vue&type=script&lang=js"
export * from "./leaderboard.vue?vue&type=script&lang=js"
import style0 from "./leaderboard.vue?vue&type=style&index=0&id=3dedd6fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dedd6fa",
  null
  
)

export default component.exports